import { render } from "./CustomerAccess.vue?vue&type=template&id=72070940"
import script from "./CustomerAccess.vue?vue&type=script&lang=js"
export * from "./CustomerAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__